module.exports = {"id":"193064","name":"Carlos David","rating":"71","photo":"./data/images/photos/4/193064.png","club":{"name":"SD Huesca","logo":"./data/images/clubs/SDHuesca.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CarlosDavid0.json
// module id = 714
// module chunks = 0